import { FileIcon, ImageIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'

const AttachmentTypeEnum = z.enum(['pdf', 'jpg', 'png'] as const)

interface AttachmentProps {
  fileType: string
}

export const Attachment = ({ fileType }: AttachmentProps) => {
  const { t } = useTranslation(['eventManagement'])

  return (
    <div className="attachment">
      <div className={`attachment__icon attachment__icon--${fileType}`}>
        {fileType === AttachmentTypeEnum.enum.pdf ? <FileIcon /> : <ImageIcon />}
      </div>
      <div className="attachment__info">
        <span>{t('eventManagement:common.file')}</span>
        <span>{fileType.toUpperCase()}</span>
      </div>
    </div>
  )
}
